module.exports = {
    'Customer Panel': 'Customer Panel',
    'User account management panel.': 'User account management panel.',
    'User Id': 'User Id',
    'Password': 'Password',
    'Enter user id': 'Enter user id',
    'Enter password': 'Enter password',
    'Log In': 'Log In',
    'Don\'t have an account ?': 'Don\'t have an account ?',
    'Open Live Account': 'Open Live Account',
    // views/login/index.js
    'Dashboard':'Dashboard',
    'Welcome to Customer Panel':'Welcome to Customer Panel',
    'User Accounts':'User Accounts',
    'Select the account to be active.':'Select the account to be active.',
    'Account':'Account',
    'Name':'Name',
    'Equity':'Equity',
    'Balance':'Balance',
    'Margin':'Margin',
    'Free Margin':'Free Margin',
    'Margin Level':'Margin Level',
    'Profit':'Profit',
    'Total Withdrawal':'Total Withdrawal',
    'All transactions made to date':'All transactions made to date',
    'Total Deposit':'Total Deposit',
    'Latest Money Transfers':'Latest Money Transfers',
    'Last transfer transactions':'Last transfer transactions',
    'Login':'Login',
    'PSP':'PSP',
    'Date':'Date',
    'Amount':'Amount',
    'Status':'Status',
    'Deposit':'Deposit',
    'Withdrawal':'Withdrawal',
    'Open Positions':'Open Positions',
    'Your open transactions':'Your open transactions',
    'No Record':'No Record',
    'You have no open orders':'You have no open orders',
    'Order':'Order',
    'Time':'Time',
    'Type':'Type',
    'Size':'Size',
    'Symbol':'Symbol',
    'Price':'Price',
    'Swap':'Swap',
    'You have no pending orders':'You have no pending orders',
    'Pending Orders':'Pending Orders',
    'Your pending transactions':'Your pending transactions',
    'Account History':'Account History',
    'My Documents':'My Documents',
    'Research':'Research',
    'Logout':'Logout',
    'ACCOUNTS':'ACCOUNTS',
    'COMMON':'COMMON',
    'Withdrawal History':'Withdrawal History',
    'Recent successful withdrawals':'Recent successful withdrawals',
    'You have no successful withdrawal transactions':'You have no successful withdrawal transactions',
    'Deposit History':'Deposit History',
    'You have no successful deposit transactions':'You have no successful deposit transactions',
    // views/layout/sidebar.js
}